import styles from './styles.module.sass';
import { UiButton } from '@@/ui/components/ui-button';
import { useId, useState } from 'react';
import { ModalDialog } from '@ui/modal-dialog';
import { UiTextField } from '@@/ui/components/ui-text-field';
import {
  $copyBagModalEnable,
  copyAgricultureModal,
} from '@@/agriculture/store/agriculture.store';
import { DiContainer } from '@@/di/di-container';
import { WarehousesService } from '@@/warehouses/services/warehouses.service';
import { useStore } from 'effector-react';
// import { $selectedSleeveId } from '@widgets/storage-viewer/model';
import {
  $warehouseInfo,
  $warehouseStatistic,
  addWarehouseBag,
  fillWarehouseBagSuccess,
} from '@entities/warehouse/store';
import { notification } from 'antd';
import { declineWord } from '@/modules/common/helpers/decline-word.helper';

const warehousesService = DiContainer.get(WarehousesService);

export function CopyBagModal({
  availableCount,
  bagType,
  bagId,
  warehouseId,
}: ICopyBagModal) {
  let isLoading = false;
  const formId = useId();
  const [fillCount, setFillCount] = useState<number>(0);
  const onClose = () => {
    copyAgricultureModal(null);
  };

  const warehouse = useStore($warehouseInfo);
  const whStat = useStore($warehouseStatistic);

  // const selectedSleeveId = useStore($selectedSleeveId);
  const copyBagModalEnable = useStore($copyBagModalEnable);

  const licensesRemainder: number | string =
    typeof whStat?.licence_count === 'number' && typeof whStat?.max_bags === 'number'
      ? whStat.max_bags - whStat.licence_count
      : '_';
  const copy = async (e: React.FormEvent<HTMLFormElement>) => {
    try {
      e.preventDefault();
      // console.log(fillCount, warehouse?.id, copyBagModalEnable);
      if (!fillCount || !warehouse?.id || !copyBagModalEnable) return;
      isLoading = true;
      const result: any = await warehousesService.copy(
        warehouse.id.toString(),
        copyBagModalEnable,
        fillCount.toString(),
      );
      isLoading = false;
      fillWarehouseBagSuccess({
        warehouse_id: warehouse?.id,
        filling_date: warehouse.fillData,
        fill_count: fillCount,
      } as any);
      copyAgricultureModal(null);
      // addWarehouseBag(warehouse.id.toLocaleString());
    } catch (err: any) {
      if (err.error) {
        notification.error({
          message:
            err.error || 'Ошибка при обработке данных. Попробуйте, пожалуйста, позже',
        });
        return;
      }
    }
  };
  const wordDeclinationOptions = {
    sleeve: ['рукавов', 'рукав', 'рукава'],
    volume: ['объёмов', 'объём', 'объёма'],
  };
  const availableCountNumber = Number(availableCount);
  const wordDeclinationOption = bagType === 'sleeve' ? 'sleeve' : 'volume';
  const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
    event.currentTarget.select();
  };

  return (
    <ModalDialog
      className={styles.modal}
      title={`Дублирование ${bagType === 'sleeve' ? 'рукава' : 'массы агрокультуры'}`}
      onClose={onClose}
      actions={
        <UiButton
          label={'Дублировать'}
          view="primary"
          type="submit"
          loading={isLoading}
          htmlForm={formId}
        />
      }
    >
      <form className={styles.form} id={formId} onSubmit={copy}>
        {bagType === 'sleeve' && (
          <div
            style={{ marginBottom: '5px' }}
          >{`Доступно свободных лицензий: ${Math.max(
            licensesRemainder,
            0,
          )} рукавов`}</div>
        )}
        <div style={{ marginBottom: '10px' }}>
          {`Доступно свободных рукавов на складе: ${declineWord(
            availableCountNumber,
            wordDeclinationOptions[wordDeclinationOption],
          )}`}
        </div>

        <UiTextField
          label={'Введите необходимое количество для копирования'}
          type="number"
          value={fillCount.toString()}
          step={1}
          required
          min={0}
          onClick={handleClick}
          onChange={({ value }) => {
            setFillCount(Number(value));
          }}
          max={availableCount}
        />
      </form>
    </ModalDialog>
  );
}

interface ICopyBagModal {
  availableCount: number;
  bagId: string | null;
  warehouseId: string | null;
  bagType: 'sleeve' | 'bunker';
}
